import { AccordionDetails, Button, Grid, Stack, Typography } from '@mui/material';
import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { useUser } from 'src/components/hooks/useUser';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import forms from '../../../resources/forms.json';
import { usePermissionWrapper } from '../../hooks/usePermissionWrapper';
import { useSiteContactInfo } from './useSitecontactinfo';

const SiteInformation: React.FunctionComponent<any> = ({
  siteStudyPersonnelQueryData,
  siteStudyPersonnelQueryDataIsSuccess,
  siteStudyPersonnelQueryDataLoading,
  siteTsdaStudyPersonnelQueryData,
  siteTsdaStudyPersonnelQueryDataIsSuccess,
  siteTsdaStudyPersonnelQueryDataLoading,
  setIsNavigateToPannel,
  ItIsSQ
}: any) => {
  const [siteInfoData, setSiteInfoData] = React.useState({} as any);
  const dispatch = useDispatch();
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { user } = useUser();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const application = process.env.REACT_APP_NAME;

  const formGroup = ItIsSQ
    ? forms.siteContactInformation_SiteInformation_Disable
    : forms.siteContactInformation_SiteInformation;
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups);
  const { groups } = formFields;
  const formRef: any = useRef(null);
  const { checkPermission } = usePermissionWrapper();
  const { siteInformationFields } = useFieldTranslation();
  const isEdit = checkPermission('update_infodetails');
  const [isSaveBtnEnable, setIsSaveBtnEnable] = React.useState(false);
  const handleSubmit = () => {
    formRef.current.submit(onFormSubmit);
    setIsNavigateToPannel && setIsNavigateToPannel(true);
  };
  const { getSiteStudyPersonnelQueryData, updateSiteInfo, updateStudyIdentified } = useSiteContactInfo();
  const dispatchApp = useAppDispatch();
  const onFormSubmit = (data: any) => {
    if (!data.errors) {
      if (data.success && JSON.stringify(data.records) !== JSON.stringify(siteInfoData)) {
        updateSiteInfomation(data.records);
      } else {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      }
    }
  };
  const onchange = () => {
    setConfirmExitValue(dispatch, true);
    setIsNavigateToPannel && setIsNavigateToPannel(false);
    setIsSaveBtnEnable(true);
  };
  const getData = async (funcCall = '') => {
    if (funcCall !== '') {
      await getSiteStudyPersonnelQueryData({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application
      });
    }
  };
  useEffect(() => {
    if (siteStudyPersonnelQueryData && siteStudyPersonnelQueryDataIsSuccess && !siteStudyPersonnelQueryDataLoading) {
      setSiteInfoData({ ...defaultValues, ...siteStudyPersonnelQueryData.site, ...siteStudyPersonnelQueryData.study });
    }
  }, [siteStudyPersonnelQueryData, siteStudyPersonnelQueryDataIsSuccess, siteStudyPersonnelQueryDataLoading]);

  useEffect(() => {
    if (
      siteTsdaStudyPersonnelQueryData &&
      siteTsdaStudyPersonnelQueryDataIsSuccess &&
      !siteTsdaStudyPersonnelQueryDataLoading
    ) {
      setSiteInfoData({
        ...defaultValues,
        ...siteTsdaStudyPersonnelQueryData.site,
        ...siteTsdaStudyPersonnelQueryData.study
      });
    }
  }, [
    siteTsdaStudyPersonnelQueryData,
    siteTsdaStudyPersonnelQueryDataIsSuccess,
    siteTsdaStudyPersonnelQueryDataLoading
  ]);

  const updateSiteInfomation = async (siteInfoData: any) => {
    if (checkPermission('update_infodetails')) {
      await updateSiteInfo({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        data: siteInfoData
      });
      setConfirmExitValue(dispatch, false);
    }
    if (checkPermission('study_identified')) {
      const compareData = async () => {
        if (
          siteStudyPersonnelQueryData?.site?.identified_for_study !== siteInfoData?.identified_for_study ||
          siteTsdaStudyPersonnelQueryData?.site?.identified_for_study !== siteInfoData?.identified_for_study
        ) {
          await updateStudyIdentified({
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            application: process.env.REACT_APP_NAME,
            data: {
              identified_for_study: siteInfoData.identified_for_study,
              updated_by: user
            }
          });
          setConfirmExitValue(dispatch, false);
        }
      };
      compareData();
    }
    getData('load site');
  };
  return (
    <>
      {siteInfoData?.site_id ? (
        <AccordionDetails>
          <Typography>
            <div className="site-information-block">
              <FormLayoutBuilder
                key={`site-information-block-${ItIsSQ}-${siteInfoData.site_id}`}
                isDisableRule
                initialValues={siteInfoData.site_id ? siteInfoData : defaultValues}
                rules={rules}
                ref={formRef}
                groups={groups}
                translationValues={siteInformationFields}
                columnSpacing={2}
                onChange={onchange}
              />
            </div>
            <Grid container spacing={2} mt={1}>
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <Stack spacing={2} direction="row">
                  {checkPermission('study_identified') || isEdit ? (
                    <Button onClick={handleSubmit} variant="text" disabled={!isSaveBtnEnable}>
                      SAVE
                    </Button>
                  ) : (
                    ''
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Typography>
        </AccordionDetails>
      ) : null}
    </>
  );
};

export default SiteInformation;
